/**
 *
 * clip reducer
 *
 */

import {
    LOAD_CLIP,
    SET_CLIP_DATA,
    LOAD_CLIP_ERROR,
    RESET_CLIP_DATA
} from './clip-constants';

const initialState = {
    loading: false,
    data: {},
    error: {},
};

const clipReducer = (state = initialState, action) => {

    switch (action.type) {

        case LOAD_CLIP:
            return {
                ...state,
                loading: true,
                error: {},
            };
        case SET_CLIP_DATA:
            return {
                ...state,
                data: action.data,
                loading: false,
            };
        case LOAD_CLIP_ERROR:
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        case RESET_CLIP_DATA:
            return {
                ...state,
                data: {},
            };
        default:
            return state;

    }

};

export default clipReducer;
